import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { getCalendarRequests } from "../../api/apiCall";
import { Controller, useForm } from "react-hook-form";
import { useAuth } from "../../auth/auth";
import { format } from "date-fns";
import { TextField, Box, Button } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CalendarDownloads = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, control } = useForm({
    defaultValues: {
      pts: "",
      fromDate: null,
      toDate: null,
    },
  });

  const fetchWorkers = async (filters?: any) => {
    try {
      setLoading(true);

      const response: any = await getCalendarRequests(
        state.user?.token,
        filters
      );

      setWorkers(response.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  const onSubmit = (data: any) => {
    const payload = {
      pts: data.pts || undefined,
      fromDate: data.fromDate
        ? dayjs(data.fromDate).format("YYYY-MM-DD")
        : undefined,
      toDate: data.toDate
        ? dayjs(data.toDate).format("YYYY-MM-DD")
        : undefined,
    };

    fetchWorkers(payload);
  };

  const columns: any[] = [
    { field: "name", headerName: "Full Name", flex: 1 },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "year",
      headerName: "Railway Year",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "appliedOn",
      headerName: "Applied On",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) =>
        format(
          new Date(params.row.appliedOn || Date.now()),
          "dd/MM/yyyy"
        ),
    },
  ];

  return (
    <>
      <div className="form-content">
        <TextField
          label="PTS"
          size="small"
          {...register("pts")}
          sx={{ width: 250, margin: 1 }}
        />

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name="fromDate"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                slotProps={{textField: { size: 'small' } }}
                label="From Date"
                sx={{ width: 250, margin: 1 }} />
            )}
          />

          <Controller
            name="toDate"
            control={control}
            render={({ field }) => (
              <DatePicker
              {...field}
              slotProps={{textField: { size: 'small' } }}
              label="To Date"
              sx={{ width: 250, margin: 1 }} />
            )}
          />
        </LocalizationProvider>

        <Button
          type="submit"
          onClick={handleSubmit(onSubmit)}
          variant="contained"
          sx={{m: 1.1, boxShadow: "none", height: 35, width: 180}}
        >
          Search
        </Button>
      </div>

      {/* TABLE */}
      <Box sx={{ height: 785, width: "70%", margin: "0 auto" }}>
        <DataGrid
          rows={workers}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          pageSizeOptions={[100]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15,
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#f0f0f0",
              fontWeight: "bold",
            },
          }}
        />
      </Box>
    </>
  );
};

export default CalendarDownloads;
